import { clearTokens } from './authTokens';

const AUTH_ERROR_KEY = 'auth_error';

export const clearSession = (message?: string) => {
  clearTokens();
  localStorage.removeItem('user');

  if (message) {
    sessionStorage.setItem(AUTH_ERROR_KEY, message);
  }

  window.location.href = '/';
};

export const consumeAuthError = (): string | null => {
  const message = sessionStorage.getItem(AUTH_ERROR_KEY);
  if (message) {
    sessionStorage.removeItem(AUTH_ERROR_KEY);
  }
  return message;
};
